export const API = {
  VALIDATE_TOKEN: '/api/builtin/token/validate_recovery_password_token',
  RECOVERY_PASSWORD: '/api/legacy/account/recovery_password',
  RESET_PASSWORD: '/api/legacy/account/reset_password'
}